import Config from '@config';
import { createApi } from '@reduxjs/toolkit/query/react';

import { CACHE_EXPIRATION_TIME } from '@/features/constants';
import axiosBaseQuery from '@/utils/axiosBaseQuery';

import {
  ConsumptionResponse,
  ConsumptionResponseFilters,
  RecordItem,
} from './types';

export const counterpartyActualExpensesApi = createApi({
  reducerPath: 'counterpartyActualExpensesApi',
  baseQuery: axiosBaseQuery({
    baseUrl: `${Config.VITE_API_URL}/counterparty-actual-expenses`,
  }),
  tagTypes: ['ConsumptionResponse', 'ConsumptionResponseMonthly'],
  keepUnusedDataFor: CACHE_EXPIRATION_TIME,
  endpoints: builder => ({
    getCounterpartyActualExpensesYearlyConsumption: builder.query<
      ConsumptionResponse,
      ConsumptionResponseFilters
    >({
      query: ({ representativeId, year, organizationIds }) => {
        const orgQueryString = organizationIds
          ?.map(id => `organizationIds=${id}`)
          .join('&');

        return {
          url: `/yearly-consumption?representativeId=${representativeId}&year=${year}${orgQueryString ? '&' + orgQueryString : ''}`,
          method: 'POST',
        };
      },

      providesTags: () => ['ConsumptionResponse'],
    }),
    getCounterpartyActualExpensesMonthlyConsumption: builder.query<
      RecordItem,
      { representativeId: string }
    >({
      query: ({ representativeId }) => ({
        url: `/monthly-consumption`,
        method: 'POST',
        params: { representativeId },
      }),
      providesTags: () => ['ConsumptionResponseMonthly'],
    }),
  }),
});

export const {
  useGetCounterpartyActualExpensesYearlyConsumptionQuery,
  useGetCounterpartyActualExpensesMonthlyConsumptionQuery,
} = counterpartyActualExpensesApi;
